import { useEffect, useState } from "react";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, Eyebrow } from "../components/Reveal";
import { scrollToId } from "../lib/scroll";
import { fetchPackages, imgSrc } from "../lib/api";
import { cad } from "../lib/format";

const PackageCard = ({ p }) => (
  <article data-testid={`package-card-${p.key}`} className={`group flex h-full flex-col overflow-hidden rounded-[24px] border bg-[#12141C] transition-transform duration-500 hover:-translate-y-2 ${p.featured ? "border-[#FF5A1E]/50" : "border-white/10"}`}>
    <div className="relative aspect-[16/10] overflow-hidden bg-[#0B0C10]">
      {p.image && <img src={imgSrc(p.image)} alt={p.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />}
      {p.tag && <span className={`absolute left-4 top-4 rounded-full px-3 py-1 font-mono text-[11px] uppercase tracking-widest ${p.featured ? "bg-sunset text-black" : "bg-black/60 text-white backdrop-blur"}`}>{p.tag}</span>}
    </div>
    <div className="flex flex-1 flex-col p-6">
      <h3 className="font-display text-3xl font-extrabold uppercase text-white">{p.name}</h3>
      <ul className="mt-4 flex-1 space-y-2 text-sm text-zinc-300">
        {(p.perks || []).map((perk) => <li key={perk} className="flex items-center gap-2"><Check size={15} className="shrink-0 text-sunset" />{perk}</li>)}
      </ul>
      <p className="mt-5 font-mono text-xs uppercase tracking-widest text-zinc-400">{p.price_from != null ? `From ${cad(p.price_from)}` : "Pricing coming soon"}</p>
      {p.link ? (
        <a data-testid={`package-book-btn-${p.key}`} href={p.link} target="_blank" rel="noopener noreferrer" className="btn-primary mt-4 justify-center">Book Package <ArrowUpRight size={15} /></a>
      ) : (
        <button data-testid={`package-notify-btn-${p.key}`} onClick={() => scrollToId("signup")} className="btn-ghost mt-4 justify-center">Notify Me</button>
      )}
    </div>
  </article>
);

export const Packages = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchPackages().then(setItems).catch(() => setItems([]));
  }, []);
  if (!items.length) return null;

  return (
    <section id="packages" data-testid="packages-section" className="mx-auto max-w-7xl px-5 py-20 lg:px-12 lg:py-32">
      <Reveal className="mb-12 max-w-2xl">
        <Eyebrow>Dining & Hotel Packages</Eyebrow>
        <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.9] text-white sm:text-6xl">Make a night <span className="text-gradient">of it.</span></h2>
        <p className="mt-5 text-zinc-300">Optional bundles that pair your show with dinner and a stay in Fallsview.</p>
      </Reveal>
      <div className="grid gap-6 md:grid-cols-3">
        {items.map((p, i) => <Reveal key={p.key} delay={i * 0.08}><PackageCard p={p} /></Reveal>)}
      </div>
    </section>
  );
};
